/*
 * Cart page optimizations (AC-1742)
 * - Purchase option panels under cart lines (snippets/cart-subscription-options.liquid)
 * - Cross-sell shelf "+" buttons (snippets/cart-cross-sell-row.liquid)
 * - Recently Viewed "Add to cart" buttons (theme.RecentlyViewed.appendCartActions)
 *
 * The cart section is re-rendered by refreshCart() in custom.js on `cart:updated`, which
 * replaces the section's innerHTML (or, while a panel control has focus, swaps it through
 * cartPageSwap() below), so everything here is delegated on document and bound once.
 */
(function () {
  if (window.cartPageOptimizationsInit) return;
  window.cartPageOptimizationsInit = true;

  var script = document.currentScript;
  var strings = {
    updated: (script && script.dataset.updated) || 'Cart updated',
    error: (script && script.dataset.error) || 'Something went wrong. Please try again.',
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var status;
  var alertRegion;
  var swapListener = null;
  var panelControls = {
    plan: '[data-cart-sub-plan-radio]',
    once: '[data-cart-sub-radio]:not([data-cart-sub-plan-radio])',
    frequency: '[data-cart-sub-frequency]',
  };

  function liveRegion(role, politeness) {
    var el = document.createElement('div');
    el.className = 'visually-hidden';
    el.setAttribute('role', role);
    el.setAttribute('aria-live', politeness);
    document.body.appendChild(el);
    return el;
  }

  function announce(message, isError) {
    if (!status) status = liveRegion('status', 'polite');
    if (!alertRegion) alertRegion = liveRegion('alert', 'assertive');
    var region = isError ? alertRegion : status;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 100);
  }

  function controls() {
    return document.querySelectorAll('[data-cart-sub] input, [data-cart-sub] select, [data-cart-page-add]');
  }

  function setBusy(state, activePanel) {
    busy = state;
    // The panel being changed stays enabled: arrow keys have already moved focus to the other
    // radio, and disabling the one VoiceOver is still on reads it "dimmed" or cuts the
    // announcement off (AC-1913). `busy` still blocks a second request.
    controls().forEach(function (el) {
      if (state) {
        if (!el.disabled && !(activePanel && activePanel.contains(el))) {
          el.disabled = true;
          el.setAttribute('data-cart-page-disabled', '');
        }
      } else if (el.hasAttribute('data-cart-page-disabled')) {
        el.disabled = false;
        el.removeAttribute('data-cart-page-disabled');
      }
    });
  }

  function clearErrors() {
    document.querySelectorAll('[data-cart-page-error]').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
    });
  }

  function showError(scope, message) {
    var target = scope && scope.querySelector('[data-cart-page-error]');
    if (target) {
      target.textContent = message;
      target.hidden = false;
    }
    announce(message, true);
  }

  function postJSON(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status === 422 || data.status === 'bad_request') {
          var error = new Error(data.description || data.message || strings.error);
          error.cartMessage = typeof data.description === 'string' ? data.description : data.message;
          throw error;
        }
        return data;
      });
    });
  }

  function cartSection() {
    var form = document.querySelector('form[id^=CartPageForm]');
    return form ? form.closest('[id^=shopify-section-template--]') : null;
  }

  function reinitYotpo() {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    } else if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      window.yotpo.initWidgets();
    }
  }

  // Hands the new cart to custom.js (refreshCart re-renders the section, re-runs the GWP
  // threshold check) and calls `done` once the section markup has been swapped.
  // `restoreFocus` is the fallback for a swap that could not keep the focused panel control
  // (see cartPageSwap): it runs in the task after the first frame that renders the new markup.
  // custom.js leaves focus alone for these controls, and `busy` holds until then. When it is
  // given, no "Cart updated" message is announced: the control's own state is the
  // confirmation, and a polite message talks over it.
  function refreshCart(cart, done, restoreFocus) {
    var section = cartSection();
    var finished = false;
    var observer;
    var timer;

    function settle() {
      if (restoreFocus) restoreFocus();
      setBusy(false);
      reinitYotpo();
      if (!restoreFocus) announce(strings.updated);
      if (done) done();
    }

    function finish() {
      if (finished) return;
      finished = true;
      if (swapListener === finish) swapListener = null;
      if (observer) observer.disconnect();
      window.clearTimeout(timer);
      window.requestAnimationFrame(function () {
        if (restoreFocus) {
          window.setTimeout(settle, 0);
        } else {
          settle();
        }
      });
    }

    if (section) {
      observer = new MutationObserver(finish);
      observer.observe(section, { childList: true });
    }
    // cartPageSwap() can leave the section's own child list untouched, so it reports in too.
    swapListener = finish;
    timer = window.setTimeout(finish, 8000);

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function focusFirst(selector) {
    var el = document.querySelector(selector);
    if (el && document.activeElement !== el) el.focus();
  }

  /* Section swap that keeps the focused panel control (AC-1913) */

  // Replacing the focused radio / select with a fresh node, and focusing that, left VoiceOver
  // silent in Safari however late it was focused. So while focus is in a panel, the focused
  // control and its ancestors stay in the document: at each level their siblings are replaced
  // with the new markup's, in its order, and their attributes (ids, name, `for`, line keys, the
  // form's CartPageForm id) are copied over from the new copies.

  function panelControlSelector(el) {
    if (el.matches(panelControls.plan)) return panelControls.plan;
    if (el.matches(panelControls.once)) return panelControls.once;
    if (el.matches(panelControls.frequency)) return panelControls.frequency;
    return null;
  }

  function syncAttributes(target, source) {
    Array.prototype.slice.call(target.attributes).forEach(function (attr) {
      if (!source.hasAttribute(attr.name)) target.removeAttribute(attr.name);
    });
    Array.prototype.forEach.call(source.attributes, function (attr) {
      if (target.getAttribute(attr.name) !== attr.value) target.setAttribute(attr.name, attr.value);
    });
  }

  // Every child of `parent` except `kept` gives way to the children of `source` except
  // `keptSource`, which are moved in around `kept` in their order.
  function replaceAround(parent, kept, source, keptSource) {
    Array.prototype.slice.call(parent.childNodes).forEach(function (node) {
      if (node !== kept) parent.removeChild(node);
    });
    var before = !!kept;
    Array.prototype.slice.call(source.childNodes).forEach(function (node) {
      if (node === keptSource) {
        before = false;
      } else {
        parent.insertBefore(node, before ? kept : null);
      }
    });
  }

  // Options are only replaced when the list itself changed.
  function syncSelect(select, source) {
    var same =
      select.options.length === source.options.length &&
      Array.prototype.every.call(source.options, function (option, i) {
        return option.value === select.options[i].value && option.text === select.options[i].text;
      });
    if (same) {
      Array.prototype.forEach.call(source.options, function (option, i) {
        syncAttributes(select.options[i], option);
      });
    } else {
      replaceAround(select, null, source, null);
    }
    var selected = source.querySelector('option[selected]') || source.querySelector('option');
    if (selected && select.value !== selected.value) select.value = selected.value;
  }

  function keepFocusedSwap(section, html) {
    var active = document.activeElement;
    var panel = section && active && section.contains(active) ? active.closest('[data-cart-sub]') : null;
    var selector = panel && panelControlSelector(active);
    if (!selector) return false;

    var template = document.createElement('template');
    template.innerHTML = html;
    var root = template.content;

    // Two lines of one variant give two panels: pair them up by position.
    var panelSelector = '[data-cart-sub][data-variant-id="' + panel.getAttribute('data-variant-id') + '"]';
    var oldPanels = section.querySelectorAll(panelSelector);
    var newPanels = root.querySelectorAll(panelSelector);
    var newPanel =
      newPanels.length === 1
        ? newPanels[0]
        : newPanels.length === oldPanels.length
          ? newPanels[Array.prototype.indexOf.call(oldPanels, panel)]
          : null;
    var fresh = newPanel && newPanel.querySelector(selector);
    if (!fresh) return false;

    var pairs = [];
    var kept = active;
    var source = fresh;
    while (kept !== section) {
      if (!source || source === root || source.nodeName !== kept.nodeName) return false;
      pairs.unshift([kept, source]);
      kept = kept.parentNode;
      source = source.parentNode;
    }
    // The Section Rendering API wraps the section in <div id="shopify-section-main-cart"
    // class="shopify-section">, which innerHTML nests inside the page's own section wrapper. The
    // page as first loaded has no such inner wrapper: its contents are used and it is left out.
    if (
      source !== root &&
      !(source.parentNode === root && root.children.length === 1 && source.classList.contains('shopify-section'))
    ) {
      return false;
    }

    pairs.forEach(function (pair) {
      replaceAround(kept, pair[0], source, pair[1]);
      kept = pair[0];
      source = pair[1];
    });
    pairs.forEach(function (pair) {
      syncAttributes(pair[0], pair[1]);
    });
    if (active.matches('select')) syncSelect(active, fresh);
    // Checked state from the new markup: its `checked` attributes are now on every radio.
    active
      .closest('[data-cart-sub]')
      .querySelectorAll('[data-cart-sub-radio]')
      .forEach(function (radio) {
        radio.checked = radio.hasAttribute('checked');
      });

    if (swapListener) Promise.resolve().then(swapListener);
    return true;
  }

  // Called by refreshCart() in custom.js in place of `section.innerHTML = html`. Returns false
  // when it did nothing, or gave up midway: the caller then replaces the innerHTML as before.
  window.cartPageSwap = function (section, html) {
    try {
      return keepFocusedSwap(section, html);
    } catch (error) {
      return false;
    }
  };

  /* Subscription / one-time switch */

  function checkedPlan(panel) {
    return panel.getAttribute('data-current-plan') || '';
  }

  function restoreRadios(panel) {
    var current = checkedPlan(panel);
    panel.querySelectorAll('[data-cart-sub-radio]').forEach(function (radio) {
      var isPlan = radio.hasAttribute('data-cart-sub-plan-radio');
      radio.checked = current ? isPlan : !isPlan;
    });
  }

  function switchPlan(panel, planId, focusSelector) {
    if (busy) return;
    if ((planId || '') === checkedPlan(panel)) return;

    var variantId = panel.getAttribute('data-variant-id');
    clearErrors();
    setBusy(true, panel);

    postJSON('cart/change.js', {
      // The key changes once the selling plan changes; it is re-read from the new markup.
      id: panel.getAttribute('data-line-key'),
      quantity: parseInt(panel.getAttribute('data-quantity'), 10),
      selling_plan: planId ? parseInt(planId, 10) : null,
    })
      .then(function (cart) {
        refreshCart(cart, null, function () {
          var panelSelector = '[data-cart-sub][data-variant-id="' + variantId + '"]';
          var active = document.activeElement;
          // Kept in place by cartPageSwap(): focus is where the shopper left it.
          if (active && active.closest && active.closest(panelSelector)) return;
          focusFirst(panelSelector + ' ' + focusSelector);
        });
      })
      .catch(function (error) {
        setBusy(false);
        restoreRadios(panel);
        showError(panel, error.cartMessage || strings.error);
        var checked = panel.querySelector('[data-cart-sub-radio]:checked');
        if (checked) checked.focus();
      });
  }

  document.addEventListener('change', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    var panel = target.closest('[data-cart-sub]');
    if (!panel) return;

    if (target.hasAttribute('data-cart-sub-radio')) {
      var isPlan = target.hasAttribute('data-cart-sub-plan-radio');
      switchPlan(panel, target.value, isPlan ? panelControls.plan : panelControls.once);
      return;
    }

    if (target.hasAttribute('data-cart-sub-frequency')) {
      var planRadio = panel.querySelector('[data-cart-sub-plan-radio]');
      if (!planRadio) return;
      planRadio.value = target.value;
      if (planRadio.checked) {
        switchPlan(panel, target.value, panelControls.frequency);
      }
    }
  });

  /* Cross-sell "+" and Recently Viewed "Add to cart" */

  document.addEventListener('click', function (evt) {
    var button = evt.target && evt.target.closest ? evt.target.closest('[data-cart-page-add]') : null;
    if (!button) return;
    evt.preventDefault();
    if (busy) return;

    var variantId = button.getAttribute('data-cart-page-add');
    var inSection = !!button.closest('[data-cart-cross-sell]');
    var errorScope = button.closest('[data-cart-cross-sell], .grid-product__cart-action');

    clearErrors();
    setBusy(true);

    postJSON('cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      .then(function () {
        // An empty cart renders no #CartPageForm, which refreshCart() in custom.js needs.
        if (!cartSection()) {
          window.location.reload();
          return null;
        }
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        if (!cart) return;
        refreshCart(cart, function () {
          if (inSection) {
            // The row that was clicked is gone (the product is in the cart now): land on the new line.
            focusFirst('.cart__item[data-key^="' + variantId + ':"] .cart__item-name');
          } else if (document.contains(button)) {
            button.focus();
          }
        });
      })
      .catch(function (error) {
        setBusy(false);
        showError(errorScope, error.cartMessage || strings.error);
        if (document.contains(button)) button.focus();
      });
  });
})();
